// react-routers components
import { Link } from "react-router-dom";
import moment from "moment";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

function OrdersList({ title, orders, action, shadow }) {
  const renderOrders = orders?.map(
    ({ _id, product, service, supplier, addons, startDate }) => (
      <MDBox
        key={name}
        component="li"
        display="flex"
        alignItems="center"
        py={1}
        mb={1}
      >
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <MDTypography
            variant="button"
            fontWeight="medium"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          >
            {service?.mainService} - {product?.productName} (
            {product?.productNumber})
          </MDTypography>
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          >
            {moment(startDate).fromNow()}{" "}
            {addons.length !== 0 && " with addons"}
          </MDTypography>
        </MDBox>
        <MDBox ml="auto">
          {action.type === "internal" ? (
            <MDButton
              component={Link}
              to={`/orders/${_id}`}
              variant="outlined"
              sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            >
              {action.label}
            </MDButton>
          ) : (
            <MDButton
              component="a"
              href={`/orders/${_id}`}
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              color={action.color}
            >
              {action.label}
            </MDButton>
          )}
        </MDBox>
      </MDBox>
    )
  );

  return (
    <MDBox>
      <MDBox pt={2} px={2}>
        <MDTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        >
          {title}
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {renderOrders}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

// Setting default props for the OrdersList
OrdersList.defaultProps = {
  shadow: true,
};

// Typechecking props for the OrdersList
OrdersList.propTypes = {
  title: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  shadow: PropTypes.bool,
};

export default OrdersList;
